<template>
	<div
		id="actions-wrapper"
		:class="{'is-mobile': isMobileWebApp}"
	>
		<!-- tabs -->
		<ActionTabsBlock
			:remember-scroll-position="isMobileWebApp"
		/>
	</div>
</template>

<script>
import ActionTabsBlock from '@videotools/js/blocks/ActionTabs';
import { mapGetters } from 'vuex';

export default {
	name:       'ActionsBlock',
	components: { ActionTabsBlock },
	computed:   {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
};
</script>

<style lang="scss" scoped>
	#actions-wrapper {
		height: 100%;
		padding-left: 8px;
		padding-right: 8px;

		&:not(.is-mobile) {
			padding-left: 16px;
			padding-right: 16px;
		}
	}

	.is-mobile {
		#actions-wrapper {
			height: 100%
		}
	}
</style>
